import { TankProductDetails } from '@components/_SiteWide/TankDisplay/TankProductDetails'
import { Collapse, Tabs } from 'antd'
import React, { useEffect, useState } from 'react'
import { StoreCard } from '../../../_SiteWide/StoreDisplay/StoreCard'
import { useDestinationsContext } from '../../Contexts/DestinationsContext'
import { useOrderContainersContext } from '../../Contexts/OrderContainersContext'
import { useWizardMaster } from '../../Contexts/WizardMasterContext'
import { PaneHeader } from './PaneComponents/Layout/PaneHeader'
import { ProductPaneNavigation } from './PaneComponents/ProductFooterControls/_ProductPaneNavigation'
import { StoreChooser } from './PaneComponents/StoreChooser'
const { TabPane } = Tabs

export function ProductSelect() {
  const { wizardOrder } = useWizardMaster()
  const { orderDestinations, setOrderDestinations, getImpactedTankVolumes } = useDestinationsContext()
  const { stores, updateDestinations } = useDestinationsContext()
  const { compartments } = useOrderContainersContext()
  const [activeTab, setActiveTab] = useState(0)

  useEffect(() => {
    if (wizardOrder) {
      const newDestinations = getImpactedTankVolumes(compartments)
      if (newDestinations) setOrderDestinations(newDestinations)
    }
  }, [])
  return (
    <>
      <PaneHeader title='Choose Destinations/Products' />
      <div className='pane-content product-select-pane'>
        <Tabs
          style={{ flex: 1 }}
          onChange={(key) => key && setActiveTab(parseInt(key))}
          defaultActiveKey='0'
          moreIcon={
            <span
              style={{
                cursor: 'pointer',
                backgroundColor: 'white',
                padding: '0.9rem',
                borderLeft: '1px solid lightgray',
                fontWeight: 'bold',
              }}
            >
              . . .
            </span>
          }
        >
          {orderDestinations.map((d, i) => {
            return (
              <TabPane tab={d.store_number} key={i.toString()}>
                <DestinationTabPane activeTab={activeTab} key={i} index={i} store={d} />
              </TabPane>
            )
          })}

          <TabPane tab={'Add a Dest.'} key={orderDestinations.length.toString()}>
            <StoreChooser
              activeTab={activeTab}
              showMap={false}
              isEditMode={false}
              title='Add A Destination'
              storeList={stores}
              destIndex={orderDestinations.length}
              setSelectedStore={updateDestinations}
              isReplace={false}
            />
          </TabPane>
        </Tabs>

        <ProductPaneNavigation />
      </div>
    </>
  )
}
const DestinationTabPane = ({ index, store, activeTab = 0 }) => {
  const { stores, getImpactedTankVolumes, updateDestinations, orderDestinations, setOrderDestinations } =
    useDestinationsContext()
  const { addProductToContainer, pocketsAllocated, productGroupsApi } = useOrderContainersContext()
  const { setOrderEdited, rundownToggled, currentEntryMode } = useWizardMaster()
  const [isEditMode, setIsEditMode] = useState(false)

  if (store && isEditMode) {
    return (
      <>
        <div style={{ flex: 0, overflow: 'visible' }}>
          <StoreCard
            destIndex={index}
            isEditMode={isEditMode}
            setIsEditMode={setIsEditMode}
            store={store}
            showMap={false}
          />
        </div>
        <div style={{ flex: 1 }}>
          <StoreChooser
            activeTab={activeTab}
            showMap={false}
            isEditMode={isEditMode}
            title='Replace Site'
            storeList={stores}
            setSelectedStore={updateDestinations}
            destIndex={index}
            setIsEditMode={setIsEditMode}
            isReplace
          />
        </div>
      </>
    )
  }

  if (store) {
    return (
      <>
        <div style={{ background: 'var(--gray-100)' }}>
          {store.notes && (
            <Collapse defaultActiveKey={['1']}>
              <Collapse.Panel key={'1'} header='Site Notes'>
                {store.notes}
              </Collapse.Panel>
            </Collapse>
          )}
          <StoreCard
            destIndex={index}
            isEditMode={isEditMode}
            setIsEditMode={setIsEditMode}
            store={store}
            showMap={false}
          />
        </div>
        <div className='store-details-products-container tank-management'>
          <TankProductDetails
            rundownToggled={rundownToggled}
            key={index}
            store={store}
            setOrderEdited={setOrderEdited}
            addProductToContainer={addProductToContainer}
            getImpactedTankVolumes={getImpactedTankVolumes}
            disabled={pocketsAllocated}
            setOrderDestinations={setOrderDestinations}
            firstStoreNumber={orderDestinations[0].store_number}
            currentEntryMode={currentEntryMode}
            productGroupsApi={productGroupsApi}
          />
        </div>
      </>
    )
  }
}
